import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "@/locales/en/translation.json";
import { reloadOnceForChunk } from "@/lib/lazyPage";

export const SUPPORTED = ["en", "zh", "hi", "es", "fr", "ar", "bn", "ru", "pt", "ur"];
export const RTL_LANGS = ["ar", "ur"];

// English ships in the main bundle; every other language is its own chunk, fetched on demand.
const lazyLocales = {
  type: "backend",
  init() {},
  read(lng, ns, cb) {
    if (lng === "en") return cb(null, en);
    import(/* webpackChunkName: "locale-[request]" */ `./locales/${lng}/translation.json`)
      .then((m) => cb(null, m.default || m))
      .catch((err) => {
        try { localStorage.setItem("samtwo_lang", lng); } catch {}
        if (!reloadOnceForChunk(err)) cb(err, null);
      });
  },
};

i18n
  .use(lazyLocales)
  .use(LanguageDetector)
  .use(initReactI18next);

// Resolves once the visitor's language is loaded; index.js waits on it before the first render.
export const i18nReady = i18n
  .init({
    resources: { en: { translation: en } },
    partialBundledLanguages: true,
    react: { useSuspense: false },
    fallbackLng: "en",
    supportedLngs: SUPPORTED,
    nonExplicitSupportedLngs: true, // en-US -> en
    load: "languageOnly",
    returnObjects: true, // quotes arrays, nested objects
    returnEmptyString: false,
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "samtwo_lang",
      caches: ["localStorage"],
      // navigator can report region + POSIX modifier (e.g. "en-US@posix"). Strip to bare code.
      convertDetectedLanguage: (lng) => (lng || "en").split(/[-_@.]/)[0].toLowerCase(),
    },
  })
  .catch(() => {});

export default i18n;
